import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { useEffect, useState } from "react";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { ConvertErrorArrayToString } from "../../Services/Common";
import { setToastData } from "../../Store/reducers/Toast";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";

const CreateTransferRequest = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userData, accessToken } = useSelector((state) => state.user);
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [membersList, setmembersList] = useState([]);
    const [filter, setFilter] = useState({
        org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
        div_id: userData.role_slug === "super_admin" ? 0 : userData.user_div,
    });
    useEffect(() => {
        dispatch(setPageTitle('Create Transfer Request'));
        let promiseArray = [];
        dispatch(setMainLoading(true));
        if (userData.role_slug === "super_admin") {
            promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
        }
        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" || userData.role_slug === "captain"  || userData.role_slug === "div_admin" ) {
            promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
        }
        if (promiseArray.length > 0) {

            Promise.all(promiseArray)
                .then((response) => {
                    if (response[0].config.url === "masters/organization") {
                        if (response[0].data.status === "1") {
                            setOrgList(response[0].data.data);
                        }
                    }
                    else {
                        if (response[0].data.status === "1") {
                            setDivList(response[0].data.data);
                        }
                    }
                    if (response?.[1]?.config?.url === "masters/division-list") {
                        if (response[1].data.status === "1") {
                            setDivList(response[1].data.data);
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                }).finally(() => {
                    dispatch(setMainLoading(false));
                })
        }
        else {
            fetchMembersList();
        }
    }, [accessToken, dispatch]);
    const fetchMembersList = () => {
        setmembersList([]);
        if (filter.div_id > 0) {
            dispatch(setMainLoading(true));
            let postData = {
                ...filter,
                search: ''
            }
            postData.page = 0
            postData.perPage = 1000
            PostAxios(`users`, postData, accessToken)
                .then(({ data }) => {
                    if (data.status === "1") {
                        if (data.data.length > 0) {
                            setmembersList(data.data);
                        }
                    }
                    else {
                        dispatch(setToastData({
                            message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message,
                            isHtml: true,
                            type: 'error',
                            showCloseBtn: true
                        }))
                    }
                })
                .catch(err => {
                    responseCatchFunc(dispatch, err)
                }).finally(() => {
                    dispatch(setMainLoading(false));
                })
        }
    }
    useEffect(() => {
        fetchMembersList();
    }, [filter.div_id]);
    return (
        <div className="main-form-sec">
            <Formik
                initialValues={{
                    org_id: filter.org_id,
                    div_from_id: filter.div_id,
                    div_to_id: 0,
                    mem_id: 0
                }}
                enableReinitialize={true}
                validate={values => {
                    const errors = {};
                    if (parseInt(values.org_id) < 1) { errors.org_id = "Organization ID should not be empty"; }
                    if (parseInt(values.div_from_id) < 1) { errors.div_from_id = "Please choose From Mohallah of Member"; }
                    if (parseInt(values.div_to_id) < 1) { errors.div_to_id = "Please choose To Mohallah of Member"; }
                    if (parseInt(values.mem_id) < 1) { errors.mem_id = "Please choose Member"; }
                    return errors;
                }}
                onSubmit={(values,{setSubmitting,resetForm}) => {
                    dispatch(setMainLoading(true));
                    PostAxios(`users/add-transfer-request`,
                        {
                            ...values
                        },
                        accessToken
                    )
                    .then(({data})=>{
                        console.log(data);
                        if(data.status === "1"){
                            dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }));
                            resetForm();
                            navigate("/division-transfer");
                        }
                        else{
                            dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                        }
                    })
                    .catch(err=>{
                        responseCatchFunc(dispatch,err)
                    })
                    .finally(()=>{
                        dispatch(setMainLoading(false));
                        setSubmitting(false);
                    })
                }}
            >
                {({ errors, touched, isSubmitting, handleChange, setFieldValue, values }) => (
                    <Form>
                        <div className="form-sec">
                            {
                                userData.role_slug === "super_admin" &&
                                <div className={`form-field-group w-50 ${(errors.org_id && touched.org_id) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="org_id">Organization</label>
                                    </div>
                                    <div className="w-50">
                                        <label className="select-input-outer select-100">
                                            <Field name="org_id" as="select" className="select-input" onChange={(e) => {
                                                if (e.target.value === "0") {
                                                    setFieldValue('div_id', 0);
                                                }
                                                handleChange(e);
                                                setFilter({ ...filter, org_id: e.target.value });
                                            }}>
                                                <option value="0">Choose Organization</option>
                                                {
                                                    orgList.length > 0 && orgList.map((item, index) => {
                                                        return <option value={item.ID} key={`org-list-${item.ID}`}>{item.short_name}</option>
                                                    })
                                                }
                                            </Field>
                                        </label>
                                        <ErrorMessage component="span" name="org_id" className="error-label" />
                                    </div>
                                </div>
                            }
                            {
                                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                <div className={`form-field-group w-50 ${(errors.div_from_id && touched.div_from_id) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="div_from_id">From Mohallah</label>
                                    </div>
                                    <div className="w-50">
                                        <label className="select-input-outer select-100">
                                            <Field name="div_from_id" as="select" className="select-input" onChange={(e) => {
                                                handleChange(e);
                                                setFilter({ ...filter, div_id: e.target.value });
                                            }} >
                                                <option value="0">Choose From Mohallah</option>
                                                {
                                                    divList.length > 0 && divList.map((item, index) => {
                                                        if (parseInt(item.org_id) === parseInt(values.org_id)) {
                                                            return <option value={item.ID} key={`div-list-${item.ID}-${index}`}>{item.division_name} {`(${item.division_number})`}</option>
                                                        }
                                                        return null;
                                                    })
                                                }
                                            </Field>
                                        </label>
                                        <ErrorMessage component="span" name="div_from_id" className="error-label" />
                                    </div>
                                </div>
                            }
                            {
                                divList.length > 0 && <div className={`form-field-group w-50 ${(errors.div_to_id && touched.div_to_id) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="div_to_id">To Mohallah</label>
                                    </div>
                                    <div className="w-50">
                                        <label className="select-input-outer select-100">
                                            <Field name="div_to_id" as="select" className="select-input" >
                                                <option value="0">Choose Mohallah</option>
                                                {
                                                    divList.length > 0 && divList.map((item, index) => {
                                                        if (parseInt(item.org_id) === parseInt(values.org_id) && parseInt(values.div_from_id) !== parseInt(item.ID)) {
                                                            return <option value={item.ID} key={`div-list-${item.ID}-${index}`}>{item.division_name} {`(${item.division_number})`}</option>
                                                        }
                                                        return null;
                                                    })
                                                }
                                            </Field>
                                        </label>
                                        <ErrorMessage component="span" name="div_to_id" className="error-label" />
                                    </div>
                                </div>
                            }
                            {
                                membersList.length > 0 && <div className={`form-field-group w-50 ${(errors.mem_id && touched.mem_id) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="mem_id">Member</label>
                                    </div>
                                    <div className="w-50">
                                        <label className="select-input-outer select-100">
                                            <Field name="mem_id" as="select" className="select-input" >
                                                <option value="0">Choose Member</option>
                                                {
                                                    membersList.length > 0 && membersList.map((item, index) => {
                                                        return <option value={item.id} key={`div-list-${item.id}-${index}`}>{`${item.full_name}`} {`(${item.user_its})`}</option>
                                                    })
                                                }
                                            </Field>
                                        </label>
                                        <ErrorMessage component="span" name="mem_id" className="error-label" />
                                    </div>
                                </div>
                            }
                            <div className="btm-right-btn justify-content-center my-3">
                                <button className="btn-blue btn" type="submit" disabled={isSubmitting}>Submit</button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default CreateTransferRequest